import React from "react";
import DeliveryHeader from "./DeliverySection/DeliveryHeader";
import DeliveryOptions from "./DeliverySection/DeliveryOptions";
import PaymentSection from "./DeliverySection/PaymentSection";

const DeliverySection = () => {
  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="container mx-auto px-4">
        <DeliveryHeader />
        <DeliveryOptions />
        <div className="px-4 md:px-60">
          <PaymentSection />
        </div>
      </div>
    </section>
  );
};

export default DeliverySection;
